import { useEffect, useState } from 'react'
import { touchSession } from '../lib/founder-sessions'

const HEARTBEAT_MS = 60_000

/**
 * How many distinct app sessions the founder has had since completing their
 * profile.
 *
 * Counts returning to the *app*, not to any one page — a founder who comes back
 * and goes straight to their matches has used it twice whether or not Home was
 * one of the stops. Mount once inside the startup context.
 *
 * The heartbeat only ticks while the tab is visible, so an app left open in a
 * background tab for a week does not read as one very long session that never
 * ends.
 */
export function useAppSession(userId: string, profileCompletedAt: number | null) {
  const [sessions, setSessions] = useState(0)

  useEffect(() => {
    const tick = () => setSessions(touchSession(userId, profileCompletedAt, Date.now()))

    tick()
    const timer = setInterval(() => {
      if (document.visibilityState !== 'visible') return
      tick()
    }, HEARTBEAT_MS)
    return () => clearInterval(timer)
  }, [userId, profileCompletedAt])

  return sessions
}
